export interface Category {
  slug: string;
  name: string;
  description: string;
  icon: string;
  articleCount: number;
}

export const categories: Category[] = [
  {
    slug: 'wanfa-guize',
    name: '玩法规则',
    description: '详解六合彩各种玩法规则，从基础到高级，助你快速上手',
    icon: 'ri-book-read-line',
    articleCount: 28,
  },
  {
    slug: 'xuanhao-jiqiao',
    name: '选号技巧',
    description: '专业选号策略与技巧分享，提升中奖概率的实用方法',
    icon: 'ri-lightbulb-line',
    articleCount: 35,
  },
  {
    slug: 'pingtai-pingce',
    name: '平台评测',
    description: '权威六合彩平台评测，帮你筛选安全可靠的投注渠道',
    icon: 'ri-shield-check-line',
    articleCount: 22,
  },
  {
    slug: 'kaijiang-zixun',
    name: '开奖资讯',
    description: '最新开奖结果查询、历史数据分析与走势预测',
    icon: 'ri-bar-chart-line',
    articleCount: 46,
  },
];